import React from 'react';
import { Text, DocumentV2 } from 'components';
import { typography } from 'constants/styles';
import {} from './ExternalReceiptAttachments.types';
import './ExternalReceiptAttachments.scss';
const ExternalReceiptAttachments = ({ attachments }) => (React.createElement("div", { className: "external-receipt-attachments" },
    React.createElement(Text.Regular, { size: typography.TextSize.LEVEL_200 }, "Attachments"),
    attachments.map((attachment) => (React.createElement(DocumentV2, { documentName: attachment.filename, documentURL: attachment.file, isClearable: false, isDownloadable: true, key: attachment.id })))));
export default ExternalReceiptAttachments;
